import { render, staticRenderFns } from "./maintainanceTaskDetailView.vue?vue&type=template&id=974dd83c&scoped=true"
import script from "./maintainanceTaskDetailView.vue?vue&type=script&lang=js"
export * from "./maintainanceTaskDetailView.vue?vue&type=script&lang=js"
import style0 from "./maintainanceTaskDetailView.vue?vue&type=style&index=0&id=974dd83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974dd83c",
  null
  
)

export default component.exports